import {
  EDIT_INDIVIDUAL_OPTIONS,
  DELETE_INDIVIDUAL_OPTIONS,
} from "../constants/actionTypes";
import {
  ADD_TO_BASKET_ASYNC,
  CLEANUP_ASYNC,
  COPY_OPTIONS,
  DELETE_BASKET_ASYNC,
  DELETE_OPTION_LINE_ASYNC,
  MODIFY_OPTIONS_ASYNC,
  REVERT_CHILD_LINES_ASYNC,
  UPDATE_ALL_OPTIONS_ASYNC,
  UPDATE_INDIVIDUAL_OPTIONS_ASYNC,
  UPDATE_OPTION_FOR_LINE,
} from "../constants/actionTypesTpos";
import {
  DeleteBasketPayloadType,
  EditBasketPayloadType,
} from "../types/basket";
import { AddToBasketPayloadType } from "../types/line-items";
import {
  AddToBasketAsyncAction,
  ChoicesAndLine,
  ChoicesWithLine,
  CleanupAsyncAction,
  CopyActionPayload,
  CopyOptionsAction,
  DeleteBasketAsyncAction,
  DeleteIndividualOptionsAction,
  DeleteOptionLineAsyncAction,
  EditIndividualOptionsAction,
  ModifyOptionsAsyncAction,
  RevertChildLinesAsyncAction,
  UpdateAllOptionsAsyncAction,
  UpdateIndividualOptionsAsyncAction,
  UpdateOptionForLineAction,
} from "../types/option";

const updateAllOptionsAsync = (
  payload: EditBasketPayloadType,
): UpdateAllOptionsAsyncAction => ({
  type: UPDATE_ALL_OPTIONS_ASYNC,
  payload,
});

const cleanupAsync = (lineItemId: string): CleanupAsyncAction => ({
  type: CLEANUP_ASYNC,
  lineItemId,
});

const revertChildLinesAsync = (
  lineItemId: string,
): RevertChildLinesAsyncAction => ({
  type: REVERT_CHILD_LINES_ASYNC,
  lineItemId,
});

const deleteBasketAsync = (
  payload: DeleteBasketPayloadType,
): DeleteBasketAsyncAction => {
  return { type: DELETE_BASKET_ASYNC, payload };
};

const addToBasketAsync = (
  payload: AddToBasketPayloadType,
): AddToBasketAsyncAction => {
  return { type: ADD_TO_BASKET_ASYNC, payload };
};

const modifyOptionsAsync = (
  payload: ChoicesAndLine,
): ModifyOptionsAsyncAction => ({
  type: MODIFY_OPTIONS_ASYNC,
  payload,
});

const copyOptions = (payload: CopyActionPayload): CopyOptionsAction => ({
  type: COPY_OPTIONS,
  payload,
});

const updateOptionForLine = (
  payload: ChoicesWithLine,
): UpdateOptionForLineAction => ({
  type: UPDATE_OPTION_FOR_LINE,
  payload,
});

const editIndividualOptions = (
  payload: number,
): EditIndividualOptionsAction => ({
  type: EDIT_INDIVIDUAL_OPTIONS,
  payload,
});

const updateIndividualOptionsAsync = (
  payload: number,
): UpdateIndividualOptionsAsyncAction => ({
  type: UPDATE_INDIVIDUAL_OPTIONS_ASYNC,
  payload,
});

const deleteIndividualOptions = (
  payload: number,
): DeleteIndividualOptionsAction => ({
  type: DELETE_INDIVIDUAL_OPTIONS,
  payload,
});

const deleteOptionLineAsync = (
  lineId: string,
): DeleteOptionLineAsyncAction => ({
  type: DELETE_OPTION_LINE_ASYNC,
  lineId,
});

export {
  updateAllOptionsAsync,
  deleteBasketAsync,
  addToBasketAsync,
  modifyOptionsAsync,
  copyOptions,
  updateOptionForLine,
  cleanupAsync,
  revertChildLinesAsync,
  editIndividualOptions,
  updateIndividualOptionsAsync,
  deleteIndividualOptions,
  deleteOptionLineAsync,
};
